import React, { FunctionComponent, useEffect, useMemo, useRef, useState } from 'react';
import { marketConfig } from './config';
import { useSize } from 'ahooks';
import { getLocale } from 'umi';
import LineChart from './LineChart';
import useLegendSelected from './_hooks/useLegendSelected';

export interface MarketBarProps {
  legend?: string | number;
  series: { [key in string]: any };
  xAxisData: { [key in string]: any };
  loading?: boolean;
  isShowLegendTips?: boolean;
  legendTooltipFormatter?: (...args: any[]) => void;
  tooltipFormatter?: (...args: any[]) => void;
  [key: string]: unknown;
}

const MarketBar: FunctionComponent<MarketBarProps> = ({
  legend,
  xAxisData,
  series,
  loading,
  legendTooltipFormatter,
  tooltipFormatter,
  tooltipTitle,
  isShowLegendTips = true,
  ...restProps
}) => {
  const locale = getLocale();

  const ref = useRef(null);
  const pieChart = useRef<any>(null);
  const { legendSelected, onLegendSelectedChange } = useLegendSelected(series as any);
  useSize(document.querySelector('body'));
  const size = useSize(ref);
  const [height, setHeight] = useState(280);
  const [splitNumber, setSplitNumber] = useState(3);
  const configs = useMemo(() => {
    const res = marketConfig({
      legend,
      xAxisData,
      series,
      legendSelected,
      legendTooltipFormatter,
      tooltipFormatter,
      splitNumber,
      locale,
      tooltipTitle,
      ...restProps,
    });
    return res;
  }, [
    legendTooltipFormatter,
    tooltipFormatter,
    tooltipTitle,
    legend,
    restProps,
    splitNumber,
    series,
    xAxisData,
    setSplitNumber,
    locale,
    legendSelected,
  ]);

  // console.log('xAxisData, series,',xAxisData, series,);

  useEffect(() => {
    pieChart.current?.instance()?.on('legendselectchanged', (params: any): any => {
      pieChart.current?.instance().setOption({
        legend: { selected: { [params.name]: true } },
        animation: false,
      });
      return null;
    });
    setHeight(size?.height);

    let visibleHeight = 100;
    const windowHeight = 980;
    const windowWidth = 1366;
    const windowMiddleWidth = 1533;
    const isWindowMaxHight = document.body.clientHeight > windowHeight;
    const isWindowMaxWidth = document.body.clientWidth > windowWidth;
    const isWindowMindMaxWidth = document.body.clientWidth > windowMiddleWidth;
    let splitIndex = 3;
    if ((isWindowMaxHight && isWindowMaxWidth) || (isWindowMaxHight && !isWindowMaxWidth)) {
      visibleHeight = 280;
    } else if (isWindowMindMaxWidth) {
      visibleHeight = 160;
      splitIndex = 2;
    } else {
      visibleHeight = 120;
      splitIndex = 1;
    }
    setSplitNumber(splitIndex);

    // console.log(' document.body.clientHeight', document.body.clientHeight);
    // console.log('document.body.clientWidth', document.body.clientWidth);
    // console.log('splitIndexsplitIndex', splitIndex);
    // console.log('visibleHeightvisibleHeight', visibleHeight);
    pieChart.current?.instance()?.resize({
      height: visibleHeight,
    });
    setHeight(visibleHeight);
  }, [ref?.current?.clientHeight, ref?.current?.clientWidth, setHeight, height, size, setSplitNumber, splitNumber]);

  return (
    <React.Fragment>
      <div ref={ref}>
        <LineChart style={{ height }} option={configs as any} onLegendSelectedChange={onLegendSelectedChange} />
      </div>
    </React.Fragment>
  );
};
export default MarketBar;
